import React from 'react'

import { ArticleList } from '@components/common/ArticleList'
import { SectionTitle } from '@modules/Dashboard/Home/components/SectionTitle'

import {
  launchingMembershipsArticle,
  membershipsStrategiesArticle,
  perksGuideArticle,
  quickStartGuideArticle,
} from '../../../../consts'
import { useOverviewContext } from '../../hooks/useOverviewContext'
import { ArticlesSkeleton } from './ArticlesSkeleton'

export const Articles = () => {
  const overview = useOverviewContext()

  if (overview.isLoading || overview.hasAnyTier === null || overview.membersCount === null)
    return <ArticlesSkeleton />

  return (
    <div>
      <SectionTitle title="Guides & tips" />
      <ArticleList
        items={[
          ...(overview.hasAnyTier && overview.membersCount < 10
            ? [launchingMembershipsArticle]
            : []),
          ...(overview.membersCount < 3 ? [quickStartGuideArticle] : []),
          membershipsStrategiesArticle,
          perksGuideArticle,
        ]}
      />
    </div>
  )
}
